export default __webpack_public_path__ + "static/media/vehicle.9a38bc372920a43a70ec9f498652e76b.svg";